import { FormControlLabel, FormControlLabelProps } from '@mui/material'
import React from 'react'

export type WcFormControlLabelProps = FormControlLabelProps;

export const WcFormControlLabel = ({...props}: WcFormControlLabelProps) => (
    <FormControlLabel {...props}></FormControlLabel>
  )